

// //toast
import toast from '@/components/Toast';

//bind_Modal
//大区绑定
import bind_modal from '@/components/AreaBind';

// // copy_Modal
// web助力
import copy_modal from '@/components/CopyModal';

// // record_Modal
import record_modal from '@/components/RecordModal';

//invite_modal
import invite_apply from '@/components/InviteApply';

// //invite_modal
import invite_team_apply from '@/components/InviteApplyTeam';

// //team_agree_modal
import game_modal from '@/components/GameModal';

// msg_Modal
import msg_modal from '@/components/MsgModal';

let utils = {
    $toast: toast,
    $bind_modal : bind_modal,
    $copy_modal : copy_modal,
    $record_modal : record_modal,
    $invite_apply : invite_apply,
    $msg_modal : msg_modal, 
    $invite_team_apply : invite_team_apply,
    $game_modal : game_modal,  
}

export default utils;